import { render } from "./points_selection.vue?vue&type=template&id=1d549a54"
import script from "./points_selection.vue?vue&type=script&lang=js"
export * from "./points_selection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__